import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect, Switch } from 'react-router-dom';
import { connect } from 'react-redux';

import Home from './containers/Home';
import UserProfile from './containers/UserProfile';
import GtoListing from './containers/GtoListing';
import PacientList from './containers/PacientList';
import Elegibility from './containers/Elegibility';
import ElegibilityResponse from './containers/ElegibilityResponse';
import GtoContainer from './containers/GtoContainer';
import GtoDetails from './containers/GtoDetails';
import ProcedureDetails from './containers/ProcedureDetails';
import GtoDetailsContainer from './containers/GtoDetailsContainer';
import GtoDetailsConcluded from './containers/GtoDetailsConcluded';

const PrivateRoutes = ({ isLogged }) => {
  if (!isLogged) {
    return <Redirect to={{ pathname: '/login' }} />;
  }

  return (
    <Fragment>
      <Switch>
        <Route path="/home" component={Home} />
        <Route path="/perfil" component={UserProfile} />
        <Route path="/guias" component={GtoContainer} />
        <Route path="/detalhes-glosa" component={GtoDetailsContainer} />
        <Route path="/detalhes-gto" component={GtoDetails} />
        <Route path="/solicitar-gto" component={GtoListing} />
        <Route path="/elegibilidade" component={Elegibility} />
        <Route path="/elegivel" component={ElegibilityResponse} />
        <Route exact path="/listagem-pacientes" component={PacientList} />
        <Route path="/faturar-procedimento" component={ProcedureDetails} />
        <Route path="/gto-faturada" component={GtoDetailsConcluded} />
        <Route render={() => <Redirect to="/home" />} />
      </Switch>
    </Fragment>
  );
};

PrivateRoutes.propTypes = {
  isLogged: PropTypes.bool.isRequired
};

const mapStateToProps = store => ({ isLogged: !!store.login.user.codigo });

export default connect(mapStateToProps)(PrivateRoutes);
